module.exports = __webpack_public_path__ + "static/media/anketa_karta_ychast.028b8e5d.doc";